import React            from 'react';
import DashboardContext from '@widesk-ui/contexts/DashboardContext';

export default function useDashboard() {
	return React.useContext(DashboardContext);
}
